import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { isValidElement } from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { findChildByType } from '../../utils/findChildByType/findChildrenByType.es.js';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';
import { Flex } from '../Flex/Flex.es.js';
import { NavBarBrand } from './NavBarBrand.es.js';
import { NavBarMenu } from './NavBarMenu.es.js';
import { NavBarDrawer as NavBarDrawer$1 } from './NavBarDrawer.es.js';
import { NavBarSubMenu } from './NavBarSubMenu.es.js';
import { NavBarDrawer, NavBar as NavBar$2, Divider } from './styled.es.js';
import { NavBarProvider } from './NavBarContext.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var NavBar = function NavBar(_a) {
  var _b = _a,
      children = _b.children,
      justify = _b.justify,
      menuLabel = _b.menuLabel,
      _b$collapseBelow = _b.collapseBelow,
      collapseBelow = _b$collapseBelow === void 0 ? "lg" : _b$collapseBelow,
      props = __objRest(_b, ["children", "justify", "menuLabel", "collapseBelow"]);

  var isMobile = useBreakpoint(collapseBelow);
  var brand = findChildByType(children, NavBarBrand);
  var menuNode = findChildByType(children, NavBarMenu);
  var menu =
  /*#__PURE__*/
  isValidElement(menuNode) &&
  /*#__PURE__*/
  React.cloneElement(menuNode, {
    justify: justify
  });
  var submenu = findChildByType(children, NavBarSubMenu);
  return (
    /* @__PURE__ */
    React.createElement(NavBarProvider, {
      value: {
        isMobile: isMobile
      }
    }, isMobile ?
    /* @__PURE__ */
    React.createElement(NavBarDrawer, __spreadValues({}, props),
    /* @__PURE__ */
    React.createElement(Flex, {
      alignItems: "center"
    },
    /* @__PURE__ */
    React.createElement(NavBarDrawer$1, {
      brand: brand,
      menu: menu,
      menuLabel: menuLabel
    }), brand), submenu) :
    /* @__PURE__ */
    React.createElement(NavBar$2, __spreadValues({}, props), brand,
    /* @__PURE__ */
    React.createElement(Divider, null), menu, submenu))
  );
};

NavBar.displayName = "NavBar";
var NavBar$1 = Object.assign(NavBar, {
  Brand: NavBarBrand,
  Menu: NavBarMenu,
  SubMenu: NavBarSubMenu
});
export { NavBar$1 as default };